import React from "react"
import ContentLoader from "react-content-loader";

export const CreateActivityLoader= props =>{
        return(<>
            {props.count && props.count > 0 && (
                          Array.from({ length: props.count }, (_, i) => (
                            <ContentLoader 
                            key={i+1}
                            speed={2}
                            width={1200}
                            height={850}
                            viewBox="0 0 1200 850"
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                        <rect x="30" y="11" rx="8" ry="8" width="135" height="14" /> 
                        <rect x="250" y="11" rx="8" ry="8" width="300" height="14" /> 
                
                        <rect x="30" y="50" rx="8" ry="8" width="135" height="14" /> 
                        <rect x="250" y="50" rx="8" ry="8" width="500" height="14" /> 
                
                        <rect x="30" y="95" rx="8" ry="8" width="135" height="14" /> 
                        <rect x="250" y="95" rx="8" ry="8" width="500" height="14" /> 
                        <rect x="250" y="120" rx="8" ry="8" width="500" height="14" /> 
                
                        <rect x="30" y="185" rx="8" ry="8" width="135" height="14" /> 
                        
                        <rect x="250" y="185" rx="8" ry="8" width="400" height="14" /> 
                        <rect x="680" y="185" rx="8" ry="8" width="400" height="14" /> 
                
                        <rect x="250" y="220" rx="8" ry="8" width="400" height="14" /> 
                        <rect x="680" y="220" rx="8" ry="8" width="400" height="14" />
                        <rect x="250" y="255" rx="8" ry="8" width="400" height="14" />
                
                        <rect x="30" y="300" rx="8" ry="8" width="135" height="14" /> 
                        <rect x="250" y="300" rx="8" ry="8" width="500" height="14" /> 
                
                        <rect x="30" y="335" rx="8" ry="8" width="135" height="14" /> 
                        <rect x="250" y="335" rx="8" ry="8" width="500" height="14" /> 
                
                        <rect x="30" y="380" rx="8" ry="8" width="135" height="14" />
                        <rect x="250" y="380" rx="8" ry="8" width="500" height="14" /> 
                
                        <rect x="30" y="440" rx="8" ry="8" width="135" height="14" /> 
                        <circle cx="280" cy="460" r="20" /> 
                        <rect x="320" y="440" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="320" y="460" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="280" cy="530" r="20" /> 
                        <rect x="320" y="510" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="320" y="530" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="280" cy="600" r="20" /> 
                        <rect x="320" y="580" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="320" y="600" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="560" cy="600" r="20" /> 
                        <rect x="600" y="510" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="600" y="530" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="560" cy="530" r="20" /> 
                        <rect x="600" y="440" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="600" y="460" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="560" cy="460" r="20" /> 
                        <rect x="600" y="580" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="600" y="600" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="805" cy="600" r="20" /> 
                        <rect x="840" y="510" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="840" y="530" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="805" cy="530" r="20" /> 
                        <rect x="840" y="440" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="840" y="460" rx="8" ry="8" width="120" height="12" /> 
                
                        <circle cx="805" cy="460" r="20" /> 
                        <rect x="840" y="580" rx="8" ry="8" width="140" height="12" /> 
                        <rect x="840" y="600" rx="8" ry="8" width="120" height="12" /> 
                
                        <rect x="30" y="660" rx="8" ry="8" width="135" height="14" />
                        <rect x="250" y="660" rx="8" ry="8" width="300" height="14" /> 
                    </ContentLoader>
                
                          ))
                      )}</>)
    }
